<template>
    <v-container class="pa-0 ma-0">
        <v-select-filled
            v-model="value"
            :items="items"
            attach
            chips
            return-object
            :label="label"
            multiple
            readonly
            single-line
            :hide-details="hideDetails"
            :class="selectClass"
            :disabled="disabled"
            @click="openDialog()"
            density="compact"
            item-title="name"
            v-bind="vSelectProps ?? {}"
        >
            <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0" @click="openDialog()">
                    <span>{{
                        item.name.length > chipMaxLength
                            ? item.name.substring(0, chipMaxLength) + "..."
                            : item.name
                    }}</span>
                </v-chip>
                <span v-if="index === 1" class="text-grey caption" @click="openDialog()"
                    >(+{{ value.length - 1 }} autre{{ value.length === 2 ? "" : "s" }})</span
                >
            </template>
        </v-select-filled>
        <oss-dialog
            v-model="dialogCompanySelection"
            v-if="dialogCompanySelection"
            :max-width="!$vuetify.display.mobile ? '800px' : undefined"
            :min-height="!$vuetify.display.mobile ? '300px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            :title="'Sélectionnez une société'"
            prefixDataCy="ossCompanySelector-valid"
        >
            <v-card-text class="pt-3" style="min-width: 100%">
                <v-text-field-filled
                    v-model="companySearch"
                    :items="[]"
                    outlined
                    label="Entrez le nom d'une société"
                    autofocus
                    density="compact"
                    data-cy="OssCompanySelector-search"
                />
                <v-row no-gutters v-if="multiple">
                    <v-col cols="6" class="d-flex justify-center">
                        <v-btn variant="plain" color="primary" @click="selectAll()">
                            Tout sélectionner
                            <v-icon color="primary" right>$check_box</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-btn variant="plain" color="primary" @click="clearAll()">
                            Tout désélectionner
                            <v-icon color="primary" right>$check_box_outline_blank</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-list data-cy="OssCompanySelector-companies" style="overflow-y: auto">
                    <v-list-item
                        v-for="(company, index) in companies"
                        :key="index"
                        @click="isAdd(company)"
                        class="mb-2"
                        :data-cy="'OssCompanySelector-select-' + index"
                        border="sm"
                        rounded="lg"
                    >
                        <!-- <v-list-item-title>
                                <div><strong>{{ getCompanyDisplayName(company) }}</strong></div>
                                <div class="overline">Siret: {{company.siret}}</div>
                            </v-list-item-title> -->

                        <template v-slot:append>
                            <v-icon v-if="isSelected(company)" color="primary">
                                {{ multiple ? "$check_box" : "$radio_button_checked" }}
                            </v-icon>
                            <v-icon v-else>
                                {{
                                    multiple
                                        ? "$check_box_outline_blank"
                                        : "$radio_button_unchecked"
                                }}
                            </v-icon>
                        </template>
                        <v-list-item-title class="text-wrap">
                            {{ getCompanyDisplayName(company) }} </v-list-item-title
                        ><v-list-item-subtitle
                            >Siret: {{ getSiretValue(company.sire) }}</v-list-item-subtitle
                        ></v-list-item
                    >
                </v-list>
            </v-card-text>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { getSiretValue } from "../../../src/services/companyServices";
import { Component, Model, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class ossCompanySelector extends Vue {
    @Prop({ default: [] }) items;
    @Prop({ default: false, type: Boolean }) multiple: boolean;
    @Prop({ default: "Société" }) label;
    @Prop({ default: false }) hideDetails;
    @Prop({ default: "" }) selectClass: string;
    @Prop({ default: false }) readonly: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: 50 }) chipMaxLength: number;
    @Model() value;
    @Prop({ default: () => ({}) }) vSelectProps: { [key: string]: any };

    dialogCompanySelection = false;

    companySearch = "";

    get companies() {
        if (this.companySearch === "") {
            return this.items;
        }
        return this.items.filter((x) =>
            x.name.toLowerCase().includes(this.companySearch.toLowerCase()),
        );
    }

    openDialog() {
        if (!this.readonly) {
            this.dialogCompanySelection = true;
        }
    }

    isAdd(item) {
        if (this.multiple) {
            const verif = this.value.filter((x) => x.id !== item.id);
            if (verif.length === this.value.length) {
                this.value = [...this.value, item];
            } else {
                this.value = verif;
            }
        } else {
            this.value = item;
            this.dialogCompanySelection = false;
        }
    }

    isSelected(item) {
        if (this.multiple) {
            const verif = this.value.filter((x) => x.id !== item.id);
            if (verif.length === this.value.length) {
                return false;
            }
            return true;
        }
        if (this.value.id === item.id) {
            return true;
        }

        return false;
    }

    getCompanyDisplayName(company) {
        //   debugger
        return company.shortName || company.name;
    }

    selectAll() {
        this.value = this.items;
    }

    clearAll() {
        this.value = [];
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }
}

export default toNative(ossCompanySelector);
</script>
